export default {
    methods: {
        getImage: function (path) {
            if(path==null){
                return ;
            }
            if(path.includes("http")){
                return  path;
            }
            let url = "https://storage.googleapis.com/buddha_website/";
            return url + path;
        },
        getHomeImage: function (path) {
            if(path.includes("http")){
                return  path;
            }
            let url = "https://storage.googleapis.com/buddha_website/";
            return url + path;
        },
    }
}
